import { useLocaleCode } from 'i18n';
import { useCallback } from 'react';
import type { FormatPrice } from '../data-card';

export const useFormatPrice = () => {
  const locale = useLocaleCode();

  return useCallback(
    ({ currency = 'USD', value }: FormatPrice) => {
      const isInteger = Number.isInteger(Number(value.toFixed(2)));

      return new Intl.NumberFormat(locale, {
        currency,
        maximumFractionDigits: 2,
        minimumFractionDigits: isInteger ? 0 : 2,
        style: 'currency',
      }).format(value);
    },
    [locale],
  );
};
